// AccessDenied — shown when an authenticated user opens a page their role does
// not permit. Rendered as the `forbidden` fallback of <RequireRole> (see the
// route definitions). It is NOT a redirect — the user stays on the URL and sees
// a clear "no access" message, so deep links / bookmarks explain themselves.

import { Link } from 'react-router-dom';

export function AccessDenied(): JSX.Element {
  return (
    <>
      <div className="crm-page">
        <div className="mx-auto mt-10 flex max-w-md flex-col items-center gap-3 rounded-[var(--r-lg)] border border-border bg-surface p-8 text-center shadow-[shadow:var(--shadow-1)]">
          <div className="grid h-12 w-12 place-items-center rounded-full bg-danger/10 text-danger">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <h1 className="text-lg font-bold text-foreground">You don’t have access to this page</h1>
          <p className="text-sm text-muted">
            Your role doesn’t permit this area of the CRM. If you think this is a mistake, ask a
            workspace admin to update your access.
          </p>
          <Link
            to="/dashboard"
            className="mt-1 inline-flex h-9 items-center justify-center rounded-[var(--r-pill)] bg-[color:var(--primary)] px-4 text-sm font-semibold text-[color:var(--primary-fg)] shadow-[shadow:var(--shadow-pill)]"
          >
            Back to dashboard
          </Link>
        </div>
      </div>
    </>
  );
}
